/**
 * Sidebar nav-item matcher.
 *
 * Honors `exact: true` on item definitions so items like CORE > Events
 * (path "/events") don't prefix-match sibling-section routes such as
 * SALES > Pipeline (/events/pipeline), SALES > Automation
 * (/events/automation), CORE > Budgets (/events/budgets), etc.
 *
 * Used by Sidebar.jsx in BOTH places active state is derived:
 *   1. Per-item highlight class (gold text / background / left-border)
 *   2. The per-section auto-expand effect that opens the dropdown whose
 *      child matches the current route.
 */
export const isItemActive = (item, pathname) =>
  item.exact
    ? pathname === item.path
    : pathname === item.path || pathname.startsWith(item.path + '/');

export default isItemActive;
